import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import JoinPage from './pages/JoinPage';
import CatechismPage from './pages/CatechismPage';
import NotFoundPage from './pages/NotFoundPage';
import './styles/main.scss';

function App() {
    return (
        <div className="App">
            <ScrollToTop />
            <main>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/join" element={<JoinPage />} />
                    <Route path="/catechism-ua" element={<CatechismPage />} />
                    <Route path="/catechism-ru" element={<CatechismPage lang="ru" />} />
                    <Route path="*" element={<NotFoundPage />} />
                </Routes>
            </main>
        </div>
    );
}

export default App;
